import {
  CurrencyAmount,
  LabelValue,
  List,
  TokenBalance,
  TokenDisplay,
} from '~/components/component-library'
import { PositionBalance } from '~/components/smart-accounts/positions/types'
import { getPositionTypeLabel } from '~/components/smart-accounts/positions/utils'

export const ClankerPositionDetailsContent = ({
  balance,
}: {
  balance: PositionBalance
}) => {
  return (
    <List
      label="Claimable fees"
      items={[
        ...balance.tokens.map((token, index) => ({
          key: `${token.address}-${index}`,
          content: (
            <TokenDisplay
              address={token.address}
              chainId={balance.chainId}
              layout="two-line"
              size="base"
              protocol={getPositionTypeLabel(balance.positionType)}
            />
          ),
          meta: (
            <TokenBalance
              address={token.address}
              chainId={balance.chainId}
              tokenAmount={token.claimableAmount}
              usdValue={token.feesUsdValue ?? token.usdValue ?? undefined}
              isLoadingUsdValue={
                token.feesUsdValue === null && token.usdValue === null
              }
              layout="standard"
              size="base"
              direction="neutral"
            />
          ),
        })),
        ...(balance.tokens.length > 1
          ? [
              {
                key: 'total-fees',
                content: (
                  <LabelValue
                    label="Total fees"
                    value={
                      balance.feesUsdValue === null ? (
                        '--'
                      ) : (
                        <CurrencyAmount
                          layout="inline"
                          value={balance.feesUsdValue}
                        />
                      )
                    }
                  />
                ),
              },
            ]
          : []),
      ]}
    />
  )
}
